import { useCallback, useMemo } from 'react'
import { Fingerprint } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchDevices, FRAUD_STR as S, type DeviceRow } from './fraudApi'

/**
 * A25.09 — Отпечатки устройств. One row per fingerprint with the number of
 * accounts sharing it (multi-account signal). Dormant until
 * `/admin/antifraud/devices` ships. Placeholder permission USERS_VIEW.
 */
export function DevicesScreen() {
  const columns = useMemo<AdminColumn<DeviceRow>[]>(
    () => [
      { key: 'id', header: S.device, type: 'text' },
      { key: 'platform', header: S.platform, type: 'text' },
      { key: 'accounts', header: S.accounts, type: 'number' },
      { key: 'first_seen', header: S.firstSeen, type: 'text' },
      { key: 'last_seen', header: S.lastSeen, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchDevices, [])
  return (
    <>
      <PageHeader title={S.devices} screenId="A25.09" />
      <DataTable<DeviceRow>
        screenId="A25.09"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <Fingerprint size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
